var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"vh-100 text-center",attrs:{"align-v":"center"}},[_c('b-col',[_c('b-card',{staticClass:"hosting-card"},[_vm._v("Video hosting")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }